import { useField } from 'formik';
import React from 'react';
import { useState } from 'react';

const Input = ({ ariaLabel, name, type, placeholder, field }) => {
  const [meta] = useField(name);
  const [visibility, setVisibility] = useState(false);

  const filterPasswordInput = () => {
    let filteredType;
    if (type !== 'password') {
      return filteredType = type
    } else {
      filteredType = visibility ? 'text' : 'password'
    }
    return filteredType
  }

  return (
    <div className='flex space-x-3 items-center relative'>
      <input
        {...field}
        aria-label={ariaLabel}
        name={name}
        type={filterPasswordInput()}
        className="appearance-none relative block w-full px-3 py-2 bg-blue-900 border border-blue-800 placeholder-gray-500 text-gray-200 rounded-md focus:outline-none focus:shadow-outline-blue focus:border-blue-300 focus:z-10 sm:text-sm sm:leading-5"
        placeholder={placeholder}
      />
      <div className='absolute' style={{position: 'absolute', top: '0.5rem', right: '1rem'}}>
        {type === 'password' && (meta.touched || !meta.touched) && meta.error === undefined &&
          <span onClick={() => setVisibility(!visibility)} className='md:right-28 lg:right-4 z-20 text-headingDark text-opacity-70 text-sm lg:text-p cursor-pointer'> 
            {visibility ? 'Hide' : 'Show'}
          </span>
        }
      </div>
    </div>
)};

export default Input;
